module.exports = __webpack_public_path__ + "static/media/graph.4a23823e.jpg";